import { CommonModule } from '@angular/common';
import { Component, Inject, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';

import { ClientUserService, GuardService } from '../../../services';
import { NotificationsService } from '../../../services/notifications/notifications.service';
import { GlobalsInterface } from '../../../types';
import { IconButtonComponent } from '../icon-button/icon-button.component';

@Component({
    selector: 'lib-notification-bell-button',
    templateUrl: './notification-bell-button.component.html',
    styleUrls: ['./notification-bell-button.component.scss'],
    standalone: true,
    imports: [IconButtonComponent, CommonModule]
})
export class NotificationBellButtonComponent implements OnInit, OnDestroy {
    clientUserService = inject(ClientUserService);
    proUserService = inject(GuardService);

    hasNotifications: boolean = true;
    show: boolean = true;

    notificationCountSubscription!: Subscription;
    userExistsSubscription!: Subscription;

    constructor(
        @Inject('globals') globals: GlobalsInterface,
        private notificationService: NotificationsService,
        private router: Router
    ) {
        if (globals.appType === 'client') {
            this.show = this.clientUserService.userExists();
        } else if (globals.appType === 'pro') {
            this.show = this.proUserService.userExists();
        }
    }

    ngOnInit() {
        this.notificationCountSubscription = this.notificationService.notificationCount$.subscribe(
            count => (this.hasNotifications = count > 0)
        );
    }

    ngOnDestroy(): void {
        this.notificationCountSubscription.unsubscribe();
    }

    goToNotifications() {
        this.router.navigateByUrl('/notifications');
    }
}
